import type { Env } from '../types';

const env: Env = {
  STAGE: 'prod',

  API_BASE_URL: 'https://6j0yoseuwi.execute-api.eu-west-1.amazonaws.com',

  RECAPTCHA_V3_SITE_KEY: '6LdLmK0fAAAAAFiQ8edy697yN4jhpl1K33I8Bv-M',
};

export default env;
